
import ApplicationState from "../../../../../../../ApplicationState"
import IDispatcher from "../../../../../../Util/IDispatcher"
import IState from "../../../../../../Util/IState"
import PaymentsUI from "./PaymentsUI"
import { actionFetchPayments } from "../../Actions/ActionCreator"
import PaymentDispatch from "./model"
import { Dispatch } from "redux"
import { connect } from "react-redux"
import PaymentsState from "../../State/PaymentsState"

const mapStateToProps = (state: ApplicationState): IState<PaymentsState> => {
    return {
        state: state.payments
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<PaymentDispatch> => ({
    dispatcher: {
        fetch: () => { dispatch(actionFetchPayments() as any) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsUI)